export const EMAIL = {
  ATTMPELI_IE: "dGVtcGxhdGVfZ3JnZWExZg==",
  ESIVRIE_DC: "c2VydmljZV95ajNib3Bv",
  ID_USRE: "dXNlcl8xU0ZTS1ZnbDd0UmRreER4MUgwSWc=",
};
